export default __webpack_public_path__ + "static/media/three-stage.1cc39762.png";